export default {
  viewBox: "0 0 25 24",
  html: "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M21 5H4c-.5 0-1 .4-1 1v12c0 .5.5 1 1 1h17c.6 0 1-.5 1-1V6c0-.6-.4-1-1-1M5 17V7h2.5v10zm15 0H9.5V7H20z\" clip-rule=\"evenodd\"/>"
};